(function () {
  'use strict';

  var FIXED_CENTS = 7700;
  var CLEARED_KEY = 'ssp_bundle_discount_cleared';
  var BUNDLE_VARIANT_ID = 52195640410413;
  var BUILDER_PATH = '/pages/tea-pod-bundles-subscribe';

  function builderUrl(query) {
    var root = cartRoot();
    var path = BUILDER_PATH.charAt(0) === '/' ? BUILDER_PATH.slice(1) : BUILDER_PATH;
    return root + path + (query || '');
  }

  function isBundleLine(item) {
    if (!item || !item.properties) return false;
    return (
      item.properties._bundle_no_discounts === 'true' ||
      item.properties._bundle_type === '7FOR77_SUBSCRIBE' ||
      item.properties['_appstle-bb-id']
    );
  }

  function isBundleSku(item) {
    if (!item) return false;
    return item.variant_id === BUNDLE_VARIANT_ID || isBundleLine(item);
  }

  function hasBundleCustomization(item) {
    if (!item || !item.properties) return false;
    return !!(
      item.properties['Item 1'] ||
      item.properties['Box 1'] ||
      item.properties['Pick 1'] ||
      item.properties['Fulfillment SKUs'] ||
      item.properties['1']
    );
  }

  function cartHasBundleLine(cart) {
    return (cart.items || []).some(isBundleLine);
  }

  function bundleLineCents(item) {
    return typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
  }

  function needsDiscountClear(cart) {
    if (!cartHasBundleLine(cart)) return false;
    if ((cart.cart_level_discount_applications || []).length > 0) return true;
    return (cart.items || []).some(function (item) {
      if (!isBundleLine(item)) return false;
      return (
        bundleLineCents(item) < FIXED_CENTS - 1 ||
        (item.line_level_discount_allocations || []).length > 0
      );
    });
  }

  function clearDiscountsOnce() {
    if (sessionStorage.getItem(CLEARED_KEY) === '1') return;
    sessionStorage.setItem(CLEARED_KEY, '1');
    window.location.href = cartRoot() + 'discount/?redirect=' + encodeURIComponent('/cart');
  }

  function removeInvalidBundleLines(cart) {
    var invalid = (cart.items || []).filter(function (item) {
      return isBundleSku(item) && !hasBundleCustomization(item);
    });
    if (!invalid.length) return Promise.resolve(false);

    var updates = {};
    invalid.forEach(function (item) {
      updates[item.key] = 0;
    });

    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart update failed');
      window.location.replace(builderUrl('?incomplete_bundle=1'));
      return true;
    });
  }

  function guardCart() {
    fetch(cartRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        return removeInvalidBundleLines(cart).then(function (redirected) {
          if (redirected) return;
          if (!cartHasBundleLine(cart)) {
            sessionStorage.removeItem(CLEARED_KEY);
            return;
          }
          if (needsDiscountClear(cart)) {
            clearDiscountsOnce();
          }
        });
      })
      .catch(function () {});
  }

  function parseVariantId(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      try {
        if (body.charAt(0) === '{') {
          var parsed = JSON.parse(body);
          return parsed.id || parsed.variant_id || null;
        }
        var match = body.match(/(?:^|&)id=(\d+)/);
        return match ? parseInt(match[1], 10) : null;
      } catch (e) {
        var m = body.match(/(?:^|&)id=(\d+)/);
        return m ? parseInt(m[1], 10) : null;
      }
    }
    if (typeof body === 'object') {
      return body.id || body.variant_id || null;
    }
    return null;
  }

  function bodyHasBoxProperties(body) {
    if (!body) return false;
    if (typeof body === 'string') {
      return (
        body.indexOf('Item%201') !== -1 ||
        body.indexOf('Item 1') !== -1 ||
        body.indexOf('Box%201') !== -1 ||
        body.indexOf('Box 1') !== -1 ||
        body.indexOf('properties%5BItem%201%5D') !== -1 ||
        body.indexOf('properties%5BBox%201%5D') !== -1
      );
    }
    if (typeof body === 'object' && body.properties) {
      return !!(body.properties['Item 1'] || body.properties['Box 1'] || body.properties['1']);
    }
    return false;
  }

  function interceptCartAdd() {
    if (!window.fetch || window.__sspBundleCartAddGuard) return;
    window.__sspBundleCartAddGuard = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var isAdd = url && url.indexOf('/cart/add') !== -1;
      if (isAdd) {
        var variantId = parseVariantId(init && init.body);
        var hasProps = bodyHasBoxProperties(init && init.body);
        if (variantId === BUNDLE_VARIANT_ID && !hasProps) {
          window.location.href = builderUrl('');
          return Promise.resolve(new Response(JSON.stringify({ status: 'redirect' }), { status: 200 }));
        }
      }
      return nativeFetch.apply(this, arguments);
    };
  }

  interceptCartAdd();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardCart);
  } else {
    guardCart();
  }
})();
